module.exports = __webpack_public_path__ + "img/8367e6a.png";